import React, { useState, useEffect } from "react";
import { Link as RouteNavLink } from "react-router-dom";
import { Container, CardLink } from "shards-react";
import styled from "styled-components";
import useToken from "shared/hook/useToken";
import baseUrl from "config/baseUrl";
import { useTranslation } from "react-i18next";

import imgbox from "../../assets/img/imgbox.png";
const axios = require("axios").default;

const NavTab = styled.div`
  padding: 65px 0;
  cursor: pointer;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  justify-items: center;
  row-gap: 30px;
`;
const NavCard = styled.div`
  text-align: center;
  margin-bottom: 10px;
  color: ${(props) => props.color};
`;
const NavItem = styled.a`
  max-width: 207px;
  cursor: unset;
`;

const TabTitle = styled.div`
  font-weight: bold;
  text-align: center;
`;
const TabTitleSub = styled.div`
  margin-bottom: 15px;
`;
const Image = styled.img`
  max-width: 150px;
  height: 130px;
  vertical-align: middle;
  border-style: none;
  object-fit: cover;
  border-radius: 8px;
`;
const TabImage = styled.div`
  width: 100%;
  margin-bottom: 10px;
  align-content: ${(props) => props.center};
  justify-content: ${(props) => props.center};
  align-items: ${(props) => props.center};
  display: ${(props) => props.display};
  min-height: 155px;
`;
const Link = styled(RouteNavLink)`
  font-size: 16px;
  padding: 0.625rem 0;
  text-decoration: underline;
  bottom: 0;
  position: absolute;
  left: 0;
  right: 0;
  :hover {
    color: #717171;
    text-decoration: underline !important;
  }
`;
const Link3 = styled(RouteNavLink)`
  font-size: 16px;
  padding: 5px;
  text-decoration: underline;
  :hover {
    color: #717171;
    text-decoration: underline !important;
  }
`;
const StyledCardLink = styled(CardLink)`
  color: #000;
  cursor: pointer;
  max-width: 207px;
  cursor: unset;
  :hover {
    color: #000;
    @keyframes rotate {
      100% {
        transform: rotate(1turn);
      }
    }

    .animate {
      position: relative;
      z-index: 0;
      border-radius: 50%;
      overflow: hidden;
      padding: 5px;

      &::before {
        content: "";
        position: absolute;
        z-index: -2;
        left: -50%;
        top: -50%;
        width: 200%;
        height: 200%;
        background-color: #399953;
        background-repeat: no-repeat;
        background-position: 0 0, 100% 0, 100% 100%, 0 100%;
        background-image: linear-gradient(#fff, #1968bc);
        animation: rotate 2s linear infinite;
      }

      &::after {
        content: "";
        position: absolute;
        z-index: -1;
        left: 6px;
        top: 6px;
        width: calc(100% - 12px);
        height: calc(100% - 12px);
        border-radius: 5px;
      }
    }
  }
`;
const NavHeader = styled.div`
  background-color: #eff5fb !important;
`;
const TabsLogisticsSub = (props) => {
  const { contentId, match } = props;
  const { token } = useToken();
  const [dataTabList, setDataTabList] = useState(null);
  const { t, i18n } = useTranslation();
  useEffect(() => {
    if (contentId) {
      var data = JSON.stringify({
        params: {
          contentSettingId: contentId,
        },
        show: 100,
        page: 1,
        orderBy: "contentSubSettingId",
        orderType: "ASC",
      });

      var config = {
        method: "post",
        url: `${baseUrl}/v1/setting/contentsublistshow`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then((response) => {
          setDataTabList(response.data);
          // setTotalPage(response.data.totalPage);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [contentId]);
  return (
    <>
      <NavHeader>
        <Container>
          <NavTab>
            {dataTabList != null &&
              dataTabList.data.length > 0 &&
              dataTabList.data.map((item, key) => {
                let split1 = item.contentSubSettingName.split(":");
                if (i18n.language === "th") {
                  split1 = item.contentSubSettingName.split(":");
                } else {
                  split1 = item.contentSubSettingNameEN.split(":");
                }
                let split = "";
                if (split1.length > 1) {
                  split = split1[1].split("(");
                }
                return (
                  <StyledCardLink
                    key={key}
                    tag={RouteNavLink}
                    to={`/indicators/${item.contentSubSettingId}`}
                  >
                    <NavCard>
                      <TabImage center="center" display="flex">
                        <div className={contentId === 3 ? "" : "animate"}>
                          <Image
                            src={
                              item.contentSubSettingPic
                                ? `${baseUrl}/${item.contentSubSettingPic}`
                                : imgbox
                            }
                            bg={"none"}
                          />
                        </div>
                      </TabImage>
                      {split1.length > 1 ? (
                        split1.map((name, key) =>
                          key > 0 ? (
                            split.length > 1 ? (
                              <>
                                <TabTitle>
                                  {`- `}
                                  {split[0]}
                                </TabTitle>
                                <TabTitle>
                                  {`(`}
                                  {split[1]}
                                </TabTitle>
                              </>
                            ) : (
                              <TabTitle>
                                {`-`}
                                {name}
                              </TabTitle>
                            )
                          ) : (
                            <TabTitle>{name}</TabTitle>
                          )
                        )
                      ) : (
                        <TabTitle>
                          {i18n.language === "th"
                            ? item.contentSubSettingName
                            : item.contentSubSettingNameEN}
                        </TabTitle>
                      )}
                    </NavCard>
                  </StyledCardLink>
                );
              })}
          </NavTab>
        </Container>
      </NavHeader>
    </>
  );
};
export default TabsLogisticsSub;
